import { render, staticRenderFns } from "./LocationVariationListItem.vue?vue&type=template&id=3bd9a37c"
import script from "./LocationVariationListItem.vue?vue&type=script&lang=js"
export * from "./LocationVariationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports